import axios from 'axios';

export default {
  state: {
    order_detail: {},
    order_detailLoading: false,
    order_detailError: null,
    order_detailLoaded: false,
    noMoreOrder_detail: false
  },
  mutations: {
    SET_ORDER_DETAIL(state, order_detail) {
      state.order_detail = order_detail;
      state.order_detailLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_ORDER_DETAIL_LOADING(state, status) {
      state.order_detailLoading = status;
    },
    UNSET_ORDER_DETAIL(state) {
      state.order_detailLoaded = false;
      state.order_detailLoading = false;
      state.order_detail = {};
    },
    SET_ORDER_DETAIL_ERROR(state, error) {
      state.order_detailError = error;
    }
  },
  actions: {
    async fetchOrder_detail({ commit, state }, id) {
      commit('UNSET_ORDER_DETAIL');
      commit('SET_ORDER_DETAIL_LOADING', true);
      try {
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/order/'+id+'/');
        if (response.data.status == 'error') {
          commit('SET_ORDER_DETAIL_ERROR', 'Заказ не найден');
        }
        else {

          commit('SET_ORDER_DETAIL', response.data.data);
          commit('SET_ORDER_DETAIL_ERROR', null);
        }
      } catch (error) {
        commit('SET_ORDER_DETAIL_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching order_detail:', error);
      } finally {
        commit('SET_ORDER_DETAIL_LOADING', false);
      }
    }
  },
  getters: {
    order_detail: state => state.order_detail,
    order_detailLoading: state => state.order_detailLoading,
    order_detailError: state => state.order_detailError,
    order_detailLoaded: state => state.order_detailLoaded
  }
}